import detail from "./detail";
import formData from "./formData";
import prevent from "./prevent";
import stop from "./stop";
import validity from "./validity";

export default {
  detail,
  formData,
  prevent,
  stop,
  validity,
};
